import { ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { token } from "@atlaskit/tokens";

import { Link } from "@/libraries/design/components";
import { useLocalizedHref } from "@/libraries/web-framework";

import { messages } from "./messages";

const containerCss = css({
    fontFamily: token("font.family.brand.body"), // Charlie Text
    fontSize: "0.75rem",
    lineHeight: "1.125rem",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#000",
    marginBlockStart: "1rem",
    textAlign: "center",
    padding: "0 60px"
});

export const PaidJiraAiDisclaimer = () => {
    const acceptableUsePolicyLinkHref = useLocalizedHref(
        "/legal/acceptable-use-policy"
    );

    return (
        <div css={containerCss}>
            <FormattedMessage
                {...messages.acceptableUsePolicyDisclaimer}
                values={{
                    acceptableUsePolicyLink: (text: ReactNode) => (
                        <Link
                            type="inline"
                            text={text as string}
                            aria-label={text as string}
                            href={acceptableUsePolicyLinkHref}
                        />
                    )
                }}
            />
        </div>
    );
};
